<!--三行回答(问题名+答案+靠谱)-->
<template>
  <div class="message-template clearfix">
    <div class="person-icon"></div>
    <div class="message-container">
      <div class="triangle"></div>
      <div class="message">
        <template v-if="content[0].title">
          <div class="message-header">{{content[0].title}}</div>
          <div class="split-line"></div>
        </template>
        <div class="message-body">{{content[0].text}}</div>
        <div class="split-line"></div>
        <div class="message-footer" data-spm="2260480">
          <span v-show="afterClick" class="reliable-info">谢谢您的反馈!</span>
          <a href="javascript:void(0);" @click="evaluate('unreliable')" v-show="unreliableShow" class="unreliable" data-spm-click="gostr=/tulong;locaid=6049;id={{content[0].chatLogId}}"><div :class="{'clicked': clickable}" class="lightBlue disabled"><i class="icon unreliable-icon"></i></div><i class="unreliable-text disabled">不靠谱</i></a>
          <a href="javascript:void(0);" @click="evaluate('reliable')" v-show="reliableShow" class="reliable" data-spm-click="gostr=/tulong;locaid=6048;id={{content[0].chatLogId}}"><div :class="{'clicked': clickable}" class="lightRed active"><i class="icon reliable-icon"></i></div><i class="reliable-text">靠谱</i></a>
        </div>
      </div>
    </div>
  </div>
</template>
<style>

</style>
<script>
  export default {
    data() {
      return {
        afterClick: false,
        unreliableShow: true,
        reliableShow: true,
        clickable: false
      }
    },
    props: {
      content: {
        type: Array
      },

    },
    methods: {
      evaluate(key) {
        if(!this.afterClick){
          var optType = 0;
          if(key=='reliable') {
            this.unreliableShow = false;
            this.reliableShow = true;
            this.clickable = true;
          }
          if(key=='unreliable') {
            this.$dispatch('request-switch');
            this.unreliableShow = true;
            this.reliableShow = false;
            this.clickable = true;
            optType = 1;
          }
          this.afterClick = true;
          if(this.content[0].refers=='advice'){
            this.$dispatch('question-evaluate-advice', optType, this.content[0].chatLogId);
          }
          else{
            this.$dispatch('question-evaluate', optType, this.content[0].chatLogId);
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// MultiAnswers.vue?7269f1c5